import { interfaces } from "inversify";
import { AccountConfigData } from "~/backend/generated/Configuration/model/accountConfigData";
import { AccountConfigProvider } from "../AccountConfigProvider/AccountConfigProvider";
import { AccountConfigOptions } from "../AccountConfigOptions/AccountConfigOptions";
import { accountConfigProviderRTTI } from "../config.rtti";

export const getAccountConfigData =
    (container: interfaces.Container) =>
    async (sessionToken: string, options?: AccountConfigOptions): Promise<AccountConfigData> => {
        const configProvider = container.get<AccountConfigProvider>(accountConfigProviderRTTI);
        const config = await configProvider(sessionToken, options);
        return config.get();
    };
